/* ==========================================================================
   Midies — Cart reward ladder: one-time pulse when a new tier is crossed.
   assets/cart-reward-ladder.js   (OPTIONAL — the ladder works without this)

   The ladder itself is pure Liquid and re-renders server-side on every cart
   change via Symmetry's merge system. This file only adds the little green
   pulse on the 5 / 7 / 9 dot the moment it turns green.
   ========================================================================== */
(function () {
  'use strict';

  // tick order in the markup: 0 Start, 1 Free shipping, 2 = "5 pairs",
  // 3 = "7 pairs", 4 = "9 pairs". free_now 1/2/3 maps to ticks 2/3/4.
  var TICK_FOR_TIER = { 1: 2, 2: 3, 3: 4 };
  var lastFree = null;

  function check() {
    var el = document.querySelector('.crl');
    if (!el) return;

    var free = parseInt(el.getAttribute('data-crl-free'), 10) || 0;

    if (lastFree !== null && free > lastFree) {
      var ticks = el.querySelectorAll('.crl__tick');
      var t = ticks[TICK_FOR_TIER[free]];
      if (t) {
        t.classList.add('crl__tick--pulse');
        window.setTimeout(function () {
          t.classList.remove('crl__tick--pulse');
        }, 1400);
      }
    }
    lastFree = free;
  }

  function start() {
    check();
    // Symmetry rewrites the ladder's attributes/markup on cart update.
    // Watch the whole drawer for those changes and re-check.
    var host = document.querySelector('.cart-drawer') ||
               document.querySelector('.cart-drawer-modal') ||
               document.body;
    try {
      new MutationObserver(check).observe(host, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['data-crl-free']
      });
    } catch (e) { /* no-op */ }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
